module.exports = __webpack_public_path__ + "static/NTC-logo-ad373ec6408564021fc2be1c358714f6.jpg";